









































































































































import Vue from 'vue';
import { PreAccDimCode, PreAccEditDimension } from "../models/PreAccEditing";
import IconButton from '@/components/IconButton.vue';
import MoneyDisplay from '@/components/MoneyDisplay.vue';
import store, { PreAccountingStore } from "../services/PreAccountingStore";
import LookupComboBox from "@/components/LookupComboBox.vue";
import eventBus from '@/services/eventBus';
import { t } from "@/plugins/i18n";


interface Data {
    store: PreAccountingStore;
    totalTemp: number;
}

interface Methods{
    onRowClick(item: any): void;
    confirmDeletion(item: any): void;
    dimCodes(dimCodeType: number): PreAccDimCode[];
    onDimCodeValueChanged(item: any, newValue: any): void;
    onValueChanged(item: any): void;
    itemCurrency(item: any): string | undefined;

}

interface Computed{
    totalDisplay: string;
}

interface Props{
    dataItems: any[];
    dimColumns: any;
    dimCodeType: number;
}


export default Vue.extend<Data, Methods,Computed,Props>({

    data() {
        return {
            store,
            totalTemp: 0,
        };
    },
    methods:{
        onRowClick(item){
            this.totalTemp = item.dataItem.total;
            this.$emit("onRowClick",item);
        },
        confirmDeletion(item){
            this.$emit("dimDelete",item);
            item.deleting = false;
        },
        // A kontír-dimenziókód lookup az évre szűrt mmbokdimcode lista; a type
        // itt a csaccdimcodetype (5..13), a mentett érték a SZÖVEGES kód.
        dimCodes(dimCodeType){
            return this.store.dimCodes.filter((i: PreAccDimCode) => i.type == dimCodeType)
        },
        onDimCodeValueChanged(item,newValue){
            if(store.dimensionsRows.filter(x => x.head == item.head && x.dimCodeType == item.dimCodeType && x.id != item.id).some(i => i.dimCode == newValue.dimcode)){
                eventBus.$emit("error", t("Transactions_LetezikMarIlyenDimenziokoduTetel"));
            }else{
                item.dimCode = newValue.dimcode;
            }
        },
        onValueChanged(item){
            const ogItem = store.originalDimensionsRows.find(x => x.id === item.id)
            if(!ogItem)
                return

            const fieldsToCheck: (keyof PreAccEditDimension)[] = ['dimCode','total']
            for (const key of fieldsToCheck) {
                if(item[key] != (ogItem as any)[key]){
                    const exists = this.store.modifiedDimensions.some(x => x.id === item.id);
                    if (!exists) {
                        this.store.modifiedDimensions.push(item);
                    }
                    return
                }
            }

            this.store.modifiedDimensions = this.store.modifiedDimensions.filter(x=> x.id !== item.id)
        },
        itemCurrency(item){
            return store.items.find(x => x.id == item.head)?.currency ?? store.head.currency
        }
    },
    computed:{
        totalDisplay:{
            get() {
                return this.totalTemp
                ? new Intl.NumberFormat('hu-HU',{ maximumFractionDigits: 2}).format(this.totalTemp)
                : '';
            },
            set(val) {
            const normalized = val
                .replace(/\s/g, '')      // szóközök eltávolítása
                .replace(',', '.');      // magyar vessző -> JS pont

            const numeric = parseFloat(normalized);

            this.totalTemp = Number(numeric)
            }
        }
    },
    props: {
        dataItems: {
            type: Array as () => any[],
            required: true
        },
        dimColumns: {
            type: Array as () => any[],
            required: true
        },
        dimCodeType:{
            type: Number,
            required: true
        }
    },
    components:{
        IconButton,
        MoneyDisplay,
        LookupComboBox
    }
});



